import React, { FC } from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

export const ChevronLeftIcon: FC<any> = (props) => (
    <SvgIcon viewBox="0 0 18 18" {...props}>
        <g id="Modal-Prototype" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Config-Cust-Modal---Option-2.5-Copy" transform="translate(-732.000000, -604.000000)">
                <g id="Group-6" transform="translate(732.000000, 471.000000)">
                    <g id="Group-5" transform="translate(0.000000, 24.000000)">
                        <g id="Group" transform="translate(0.000000, 109.000000)">
                            <rect id="Rectangle" x="0" y="0" width="18" height="18"></rect>
                            <polyline
                                id="Path"
                                stroke="#8E8E8E"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                points="11 4 6 9 11 14"
                            ></polyline>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </SvgIcon>
);

export default ChevronLeftIcon;
